export default __webpack_public_path__ + "static/media/lunch1.7fa9f204.jpeg";